import React from "react";
import moment from "moment";
import PLANE from "../../assets/images/plane.png";
import { formatIndianNumber } from "../../_helpers/formatUtils";
import { getFlightImage } from "../../_helpers/flightUtils";
import { FlightImage } from "../../components/flightimage/FlightImage";

const ReturnFlightsFooter = ({
  selectedOnward,
  selectedReturn,
  totalOPrice,
  totalRPrice,
  handleBookNowClick,
}: any) => {
  return (
    <div className="footer-fix">
      {selectedOnward?.route && (
        <div className="flight-mobile">
          <div className="fight-name">
            <FlightImage
              key={selectedOnward?.route?.Segments[0]?.Airline_Code}
              flightCode={selectedOnward?.route?.Segments[0]?.Airline_Code}
            />
            <span>
              <h5>
                {selectedOnward?.route?.Segments?.map(
                  (segment: any, index: number, array: any[]) => {
                    const name = segment?.Airline_Name;
                    const isLastItem = index === array.length - 1;

                    // Check if the name is repeated
                    const isRepeated = array.some(
                      (s: any, i: number) =>
                        i !== index && s?.Airline_Name === name
                    );

                    // Render the name if it's the first occurrence, the last item, or if it's repeated
                    if (
                      !isRepeated ||
                      isLastItem ||
                      array.lastIndexOf(name) === index
                    ) {
                      return `${name}${!isLastItem ? ", " : ""}`;
                    }
                    return null;
                  }
                )}
              </h5>
              <p>
                {selectedOnward?.route?.Segments?.map(
                  (segment: any, index: number, array: any[]) => {
                    const flightNo = segment?.Flight_Number;
                    const flightCode = segment?.Airline_Code;
                    const isLastItem = index === array.length - 1;

                    // Check if the name is repeated
                    const isRepeated = array.some(
                      (s: any, i: number) =>
                        i !== index && s?.Flight_Number === flightNo
                    );

                    // Render the name if it's the first occurrence, the last item, or if it's repeated
                    if (
                      !isRepeated ||
                      isLastItem ||
                      array.lastIndexOf(flightNo) === index
                    ) {
                      return `${flightCode} - ${flightNo}${
                        !isLastItem ? ", " : ""
                      }`;
                    }
                    return null;
                  }
                )}
              </p>
            </span>
          </div>
          <div className="route-timing">
            <div className="route-strating">
              {moment(
                moment(selectedOnward?.route?.Segments[0]?.Departure_DateTime)
              )?.format("HH:mm")}
              <p>{selectedOnward?.route?.Segments[0]?.Origin}</p>
            </div>
            <div className="cunsume-time">
              <div className="cunsume-pic">
                <img src={PLANE} alt="" />
              </div>
            </div>
            <div className="route-strating">
              {moment(
                moment(
                  selectedOnward?.route?.Segments[
                    selectedOnward?.route?.Segments?.length - 1
                  ]?.Arrival_DateTime
                )
              )?.format("HH:mm")}
              <p>
                {
                  selectedOnward?.route?.Segments[
                    selectedOnward?.route?.Segments?.length - 1
                  ]?.Destination
                }
              </p>
            </div>
          </div>
          <div className="route-price">₹ {formatIndianNumber(totalOPrice)}</div>
        </div>
      )}
      |
      {selectedReturn?.route && (
        <div className="flight-mobile">
          <div className="fight-name">
            <FlightImage
              key={selectedReturn?.route?.Segments[0]?.Airline_Code}
              flightCode={selectedReturn?.route?.Segments[0]?.Airline_Code}
            />
            <span>
              <h5>
                {selectedReturn?.route?.Segments?.map(
                  (segment: any, index: number, array: any[]) => {
                    const name = segment?.Airline_Name;
                    const isLastItem = index === array.length - 1;

                    // Check if the name is repeated
                    const isRepeated = array.some(
                      (s: any, i: number) =>
                        i !== index && s?.Airline_Name === name
                    );

                    // Render the name if it's the first occurrence, the last item, or if it's repeated
                    if (
                      !isRepeated ||
                      isLastItem ||
                      array.lastIndexOf(name) === index
                    ) {
                      return `${name}${!isLastItem ? ", " : ""}`;
                    }
                    return null;
                  }
                )}
              </h5>
              <p>
                {selectedReturn?.route?.Segments?.map(
                  (segment: any, index: number, array: any[]) => {
                    const flightNo = segment?.Flight_Number;
                    const flightCode = segment?.Airline_Code;
                    const isLastItem = index === array.length - 1;

                    // Check if the name is repeated
                    const isRepeated = array.some(
                      (s: any, i: number) =>
                        i !== index && s?.Flight_Number === flightNo
                    );

                    // Render the name if it's the first occurrence, the last item, or if it's repeated
                    if (
                      !isRepeated ||
                      isLastItem ||
                      array.lastIndexOf(flightNo) === index
                    ) {
                      return `${flightCode} - ${flightNo}${
                        !isLastItem ? ", " : ""
                      }`;
                    }
                    return null;
                  }
                )}
              </p>
            </span>
          </div>
          <div className="route-timing">
            <div className="route-strating">
              {moment(
                moment(selectedReturn?.route?.Segments[0]?.Departure_DateTime)
              )?.format("HH:mm")}
              <p>{selectedReturn?.route?.Segments[0]?.Origin}</p>
            </div>
            <div className="cunsume-time">
              <div className="cunsume-pic">
                <img src={PLANE} alt="" />
              </div>
            </div>
            <div className="route-strating">
              {moment(
                moment(
                  selectedReturn?.route?.Segments[
                    selectedReturn?.route?.Segments?.length - 1
                  ]?.Arrival_DateTime
                )
              )?.format("HH:mm")}
              <p>
                {
                  selectedReturn?.route?.Segments[
                    selectedReturn?.route?.Segments?.length - 1
                  ]?.Destination
                }
              </p>
            </div>
          </div>
          <div className="route-price">₹ {formatIndianNumber(totalRPrice)}</div>
        </div>
      )}
      |
      {selectedOnward?.route && selectedReturn?.route && (
        <div className="footer-last">
          <div className="price">
            ₹ {formatIndianNumber(totalOPrice + totalRPrice)}
          </div>
          <a className="fill-btn" onClick={() => handleBookNowClick()}>
            Book Now
          </a>
        </div>
      )}
    </div>
  );
};

export default ReturnFlightsFooter;
